const PERMISSIONS = {
  // ────────────────────────────────────────────────────────────────────────────
  // Derived Permissions (account-level, computed)
  // ────────────────────────────────────────────────────────────────────────────
  /**
   * Derived Permission - Permission to view all agreements in reports
   */
  ReportingAllAgreementsAccess: 400,

  // ────────────────────────────────────────────────────────────────────────────
  // Elevated Admin Permissions (B2B:PMIADM, B2B:PMIDEV)
  // ────────────────────────────────────────────────────────────────────────────
  /**
   * Permission for elevated admin accounts
   */
  ManageElevatedAdmins: 502,

  /**
   * Permission for PMI Developer
   */
  ManagePMIDeveloper: 503,

  // ────────────────────────────────────────────────────────────────────────────
  // Account Admin Permissions (B2B:ADM)
  // ────────────────────────────────────────────────────────────────────────────
  /**
   * Permission to view a specific deal
   */
  ViewDeal: 1001,

  /**
   * Permission to view a specific deal
   */
  InviteDealUser: 1002,

  /**
   * Permission to View an admin/reporter's details
   */
  ViewAdminsOrReporters: 1003,

  /**
   * Permission to Invite an admin/reporter's details
   */
  InviteAdminOrReporter: 1004,

  /**
   * Permission to toggle a deal's status
   */
  ToggleDealStatus: 1007,

  /**
   * Permission to invite end user to the deal
   */
  InviteEndConsumerToDeal: 1011,

  /**
   * Permission to upload account logo
   */
  UploadAccountLogo: 1012,

  /**
   * Permission to see deal users under the given deal
   */
  ViewDealUsers: 1013,

  /**
   * Permission to update partner platform welcome section
   */
  SaveTrainingHubWelcomeContent: 1014,

  /**
   * Manage Deal Users, includes resending invite, inviting deal user, removing and editing deal user
   */
  ManageDealUsers: 1017,

  /**
   * Permission to update the primary contact for the deal
   */
  UpdateDealPrimaryContact: 1018,

  /**
   * Restore deleted user/admin
   */
  RestoreDealUser: 1019,

  /**
   * Permission to edit agreement name
   */
  EditDealName: 1021,

  /**
   * Permission to edit account name
   */
  UpdateAccountName: 1022,

  /**
   * Permission to update account 2fa
   */
  UpdateAccount2fa: 1023,

  /**
   * Permission to unassign products from deal users
   */
  UnassignProducts: 1024,
};

export default PERMISSIONS;
